import { render, staticRenderFns } from "./AddProjectSimple.vue?vue&type=template&id=7491bedc&scoped=true&"
import script from "./AddProjectSimple.vue?vue&type=script&lang=js&"
export * from "./AddProjectSimple.vue?vue&type=script&lang=js&"
import style0 from "./AddProjectSimple.vue?vue&type=style&index=0&id=7491bedc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7491bedc",
  null
  
)

export default component.exports